import { Outlet } from 'react-router';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useUrlChecker } from './hooks/useUrlChecker';
import getEnv from './env';
import { AnalyticsProvider } from './utils/analytics/AnalyticsContext';

export default function App() {
  const { isPublic } = useUrlChecker();
  return (
    <AnalyticsProvider>
      <HelmetProvider>
        <Helmet>
          <script
            type="text/javascript"
            id="hs-script-loader"
            async
            defer
            src={`//js.hs-scripts.com/${getEnv().hubspot_portal_id}.js`}
          ></script>
          {isPublic && !location.pathname.includes('localhost') && (
            <script
              id="cookieyes"
              type="text/javascript"
              src="https://cdn-cookieyes.com/client_data/f4c8903f602bc4de68ebe271/script.js"
            ></script>
          )}
        </Helmet>
        <Outlet />
      </HelmetProvider>
    </AnalyticsProvider>
  );
}
